import { LoadingStatusType } from "@/enums/enums";
import { AccountModel } from "@/model/account/accountModel";
import { ConvertToAccount } from "@/service/account/accountFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import AccountService from "../../service/account/accountService";

@Module({ namespaced: true })
class Account extends VuexModule {
  private accountListLoadingStatus = LoadingStatusType.None;
  private accountList: Array<AccountModel> = [];
  private assetAccountCodeList = ["1241", "1251"];
  private depreciationAccountCodeList = ["5307", "5308", "5101", "5102"];
  private depreciationAccountCodeIgnoreList = ["510103", "510105", "510106", "510107", "510108", "510109", "510201"];
  private accumulatedDepreciationAccountCodeList = ["1242", "1252"];

  get getAccountListLoadingStatus(): LoadingStatusType {
    return this.accountListLoadingStatus;
  }
  get getAccountList(): Array<AccountModel> {
    return this.accountList;
  }
  get getAssetAccountList(): Array<AccountModel> {
    return this.accountList.filter(
      (x: AccountModel) => x.code && this.assetAccountCodeList.includes(x.code.substring(0, 4))
    );
  }
  get getDepreciationAccountList(): Array<AccountModel> {
    return this.accountList.filter(
      (x: AccountModel) =>
        x.code &&
        this.depreciationAccountCodeList.includes(x.code.substring(0, 4)) &&
        !this.depreciationAccountCodeIgnoreList.includes(x.code)
    );
  }
  get getAccumulatedDepreciationAccountList(): Array<AccountModel> {
    return this.accountList.filter(
      (x: AccountModel) => x.code && this.accumulatedDepreciationAccountCodeList.includes(x.code.substring(0, 4))
    );
  }
  @Mutation
  public SetAccountListLoadingStatus(status: LoadingStatusType): void {
    this.accountListLoadingStatus = status;
  }
  @Mutation
  public SetAccountList(accountList: Array<AccountModel>): void {
    this.accountList = ConvertToAccount(accountList);
  }
  @Action
  public DoGetAccountList() {
    if (this.accountListLoadingStatus != LoadingStatusType.Loading) {
      this.context.commit("SetAccountListLoadingStatus", LoadingStatusType.Loading);
      AccountService.GetAccountList().then((res) => {
        this.context.commit("SetAccountList", res.data.accountList);
        this.context.commit("SetAccountListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
}

export default Account;
